import { Slide } from '@mui/material';
import React from 'react';
export default React.forwardRef((props, ref) => React.createElement(Slide, Object.assign({ ref: ref }, props, { direction: "up" })));
